import { Form, Formik } from 'formik';
import { Props, Values } from './UserProfileForm.types';
import FormField from '../../components/field/FormField';
import { useTranslation } from '../../context/translationContext';
import Button from '../../components/button/Button';
import * as Yup from 'yup';

/**
 * Form to edit current user´s profile
 */
export const UserProfileForm = ({ initialValues, onSubmit }: Props) => {
  const { t } = useTranslation();
  const _initialValues: Values = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
  };

  const ChangeCredentialsSchema = Yup.object().shape({
    email: Yup.string().required('Email is required.'),
  });

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues || _initialValues}
      onSubmit={onSubmit}
      validationSchema={ChangeCredentialsSchema}
    >
      {({ errors, touched }) => (
        <Form>
          <div className="my-4">
            <FormField
              id="firstName"
              name="firstName"
              label={t('page.user-setting.input-first-name')}
              errors={errors}
              touched={touched}
            />
          </div>
          <div className="my-4">
            <FormField
              id="lastName"
              name="lastName"
              label={t('page.user-setting.input-last-name')}
              errors={errors}
              touched={touched}
            />
          </div>
          <div className="my-4">
            <FormField
              id="email"
              name="email"
              label={t('page.user-setting.input-email')}
              errors={errors}
              touched={touched}
            />
          </div>
          <div className="my-4">
            <FormField
              id="phoneNumber"
              name="phoneNumber"
              label={t('page.user-setting.input-phone-number')}
              errors={errors}
              touched={touched}
            />
          </div>
          <Button title={t('general.save')} type="submit" color="green" showLoading />
        </Form>
      )}
    </Formik>
  );
};
